import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import type { IconProp } from '@fortawesome/fontawesome-svg-core';

@Component({
    selector: 'menu-block',
    templateUrl: './menu-block.component.html',
    styleUrls: ['./menu-block.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class MenuBlockComponent {
    @Input() active = false;
    @Input() blocked = false;
    @Input() completed = false;
    @Input() customIcon?: IconProp;
    @Input() alignment?: 'top'|'center' = 'center';

    @Output() onClick = new EventEmitter();

    menuBlockClicked() {
    	this.onClick.emit();
    }

    get icon(): IconProp|undefined {
    	if (this.customIcon) return this.customIcon;
    	if (this.active) return 'forward';
    	if (this.blocked) return 'lock';
    	if (this.completed) return 'circle-check';

    	return undefined;
    }
}
